import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { simpleSort } from "@miplatform/utils";

export const usePlanSeriesViewModel = ({ stateManager, accountId }) => {
  const [seriesGroup, setSeriesGroup] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [selectedSeries, setSelectedSeries] = useState({});
  const [selectedSeriesGroup, setSelectedSeriesGroup] = useState(null);

  const getSeriesGroup = () => {
    return stateManager.run(() => {
      return homeService.seriesGroup.getAll({
        sort: "name",
        filters: {
          accountId: { type: "guid", value: accountId },
        },
      });
    });
  };

  const getSeries = () => {
    return stateManager.run(async () => {
      const response = await homeService.series.getAll({
        sort: "name",
        filters: {
          accountId: { type: "guid", value: accountId },
          seriesGroupId: { type: "guid", value: null },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        const unassignedData = {
          id: null,
          name: "Unassigned",
          series: response.data,
        };
        return unassignedData;
      }
      return null;
    });
  };

  const handleSetSeriesGroup = async (seriesGroupData) => {
    const seriesData = await getSeries();
    const sortedSeriesGroupData = seriesGroupData.map((group) => ({
      ...group,
      series: group.series.sort((a, b) => simpleSort(a.name, b.name)),
    }));
    const combinedData = [...sortedSeriesGroupData, seriesData];
    const flattenedData = combinedData.flatMap((group) =>
      group.series.map((item) => ({
        ...item,
        groupName: group.name,
        seriesGroupId: group.id,
        groupModifiedOn: group.modifiedOn,
      }))
    );
    setSeriesGroup(flattenedData);
  };

  const handleDeleteSeries = (data) => {
    stateManager.run(async () => {
      const response = await homeService.series.delete({
        id: data.id,
        modifiedOn: data.modifiedOn,
        toastMessageConfig: {
          success: {
            text: `Series ${data.name} was deleted successfully.`,
          },
          failure: {
            text: `Failed to delete series ${data.name}.`,
          },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        setRefresh((prev) => !prev);
      }
    });
  };

  const handleDeleteSeriesGroup = (data) => {
    stateManager.run(async () => {
      const response = await homeService.seriesGroup.delete({
        id: data.seriesGroupId,
        modifiedOn: data.groupModifiedOn,
        toastMessageConfig: {
          success: {
            text: `Series group ${data.groupName} was deleted successfully.`,
          },
          failure: {
            text: `Failed to delete series group ${data.groupName}.`,
          },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        setRefresh((prev) => !prev);
      }
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    refresh,
    seriesGroup,
    getSeriesGroup,
    handleDeleteSeries,
    setRefresh,
    handleDeleteSeriesGroup,
    handleSetSeriesGroup,
    selectedSeries,
    setSelectedSeries,
    selectedSeriesGroup,
    setSelectedSeriesGroup,
  };
};
